// extracted by mini-css-extract-plugin
module.exports = {"Login":"Login_Login__1ujut","Link":"Login_Link__1AuWB"};